var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadNew(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Union_15",
    "data-name": "Union 15",
    d: "M2.55,17A2.553,2.553,0,0,1,0,14.45v-3.4a.85.85,0,1,1,1.7,0v3.4a.851.851,0,0,0,.85.85h11.9a.851.851,0,0,0,.85-.85v-3.4a.85.85,0,1,1,1.7,0v3.4A2.553,2.553,0,0,1,14.45,17ZM8.5,11.9H8.439l-.019,0h0l-.019,0h0l-.019,0h0l-.019,0h0l-.018,0h0l-.015,0H8.314l-.011,0-.012,0-.005,0a.839.839,0,0,1-.387-.221L3.649,7.4a.85.85,0,0,1,1.2-1.2L7.65,9V.85a.85.85,0,0,1,1.7,0V9l2.8-2.8a.85.85,0,1,1,1.2,1.2L9.1,11.651a.84.84,0,0,1-.387.221l0,0-.013,0-.011,0H8.68l-.016,0h0l-.018,0h0l-.019,0h0l-.019,0h0l-.019,0h0l-.019,0H8.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadNew);
export default __webpack_public_path__ + "static/media/download-new.d0aa31749da34df651c153d8d46b711d.svg";
export { ForwardRef as ReactComponent };